"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeLegendTooltip = void 0;
var attribute_legend_tooltip_component_1 = require("./attribute-legend-tooltip.component");
Object.defineProperty(exports, "AttributeLegendTooltip", { enumerable: true, get: function () { return attribute_legend_tooltip_component_1.AttributeLegendTooltip; } });
